import './utils/resizeObserverPatch';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ToasterProvider } from './context/ToasterContext';
import Toaster from './components/Toaster';



// -------------------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ToasterProvider>
      <App />
      <Toaster />
    </ToasterProvider>
  </Provider>
);
